import React  , { useState,useEffect } from "react";
import { Col, Modal, ModalBody, Row ,ModalHeader, 
    Label, Input, Form,  Alert} from "reactstrap"

import { contactsCreate } from "../../../../store/contacts/actions";
import {  useDispatch, } from "react-redux";
import { withRouter,  } from "react-router-dom";

import { connect} from "react-redux";

import PropTypes from "prop-types";
import SweetAlert from "react-bootstrap-sweetalert";
import { contactsFulllist } from "../../../../store/contacts/actions";

const CrearContactoModal = ({
    crearContactoModal,
onCloseClick,
error, loading, contactsCreated 


}) => {
    const dispatch= useDispatch();
  
  
    
    useEffect(() => {
        
        dispatch(contactsFulllist())
        
      },[dispatch]);

    console.log(error)
    console.log(loading)
    console.log(contactsCreated)
 


    const [formData, setFormData] = useState({
        username: "",
       
        documentNumber: "",
        birthdate: "2000-01-01",
        city: "" ,
        razon_social: "",
        phone: "",
        address: "",
        barrio_localidad: "",
        cargo: "",
        persona_contacto: "",
        first_name: "",
        last_name:"",
        contactType:  "",
        tipo_cliente:  ""
        
  
  
   });

    const {  username , razon_social, documentNumber, birthdate, city, phone,address,barrio_localidad,persona_contacto,
        cargo,first_name,last_name,contactType,tipo_cliente, documentType} =
         formData;
      
      
       const onChange = (e) => {
    
        const uppercaseValue = e.target.value.toUpperCase()
         setFormData({ ...formData, [e.target.name]: uppercaseValue });
       };
    
    const handleButtonClick = () => {
        onCloseClick(); // Llama a la función onCloseClick pasada como prop desde el componente padre
      
      };


      
    const optionGroupTipoIdentificacion = [
        {
    
          options: [
            { label: "CEDULA", value: "CEDULA" },
            { label: "PASAPORTE", value: "PASAPORTE" },
            { label: "CEDULA DE EXTRANJERIA", value: "CEDULA_EXTRANJERIA" },
            { label: "NIT", value: "NIT" },
            { label: "OTRO", value: "OTRO" },
            
          ],
        },
    
      ];


      const onSubmit = (e) => {
        e.preventDefault();
        
        dispatch(contactsCreate({
         razon_social,
         username,
         
         documentType,
         documentNumber,
         birthdate,
         city,
         phone,
         address,
         barrio_localidad,
         tipo_cliente,
         cargo,
         persona_contacto,
         first_name,
         last_name,
         contactType   }));

        };

         
    return ( 

        <React.Fragment>



               {/* SweetAlert                    */}
               {contactsCreated.id ? (
                                          <SweetAlert
                                            title="Hecho!"
                                            success
                                            timeout={1000}
                                            showConfirm={false}
                                          
                                                onConfirm={() => {

                                                  
                                                dispatch(contactsFulllist())
                                                  handleButtonClick()
                                                }}
                                              
                                            
                                          >
                                            Se ha creado  el caso al estatus {contactsCreated.id}
                                          </SweetAlert>
                                        ) : null}

            <Modal isOpen={crearContactoModal} toggle={onCloseClick} centered={true} >
                <ModalHeader toggle={handleButtonClick} tag="h4">
                    Crear Contacto
                        
                </ModalHeader>

                <ModalBody>

                <Form 
                                onSubmit={onSubmit}
                                >
    {/* Nombres y Apellidos */}
    <Row>
                  <Col lg={6} className="mb-3">                    
                    <Label
                      for="first_name"
                      className="form-label"
                    >
                      Nombres
                    </Label>
                    <Input 
                      id="first_name"
                      name="first_name"
                      type="text"
                      onChange={onChange}
                      
                     
                      value={first_name}
                      
                    />

                  </Col>                  
                  <Col lg={6}  className="mb-3">                    
                    <Label
                      for="apellido"
                      className="form-label"
                    >
                      Apellidos
                    </Label>
                    <Input
                      id="last_name"
                      name="last_name"
                      type="text"
                      onChange={onChange}
                      
                      value={last_name}
                                        
                      
                    />
                  
                  
                  </Col>
                </Row>

                   {/* tipo de Contacto y tipo de identificacion */}
                   <Row>
                  <Col lg={6} className="mb-3">
                      <Label
                        for="contactType"
                        className="form-label"
                      >
                      Tipo de Contacto
                      </Label>

                    <select
                            className="form-select"
                            id="contactType"
                            name="contactType"
                  
                            value={contactType}                      
                            onChange={onChange}
                            >
                              <option defaultValue ="">
                              Seleccione
                            </option>
                           <option value ="PERSONA NATURAL">
                              PERSONA NATURAL
                            </option>
                            <option value ="PERSONA JURIDICA">
                            PERSONA JURIDICA
                            </option>
                           
                            <option value ="OTRO">
                            OTRO
                            </option>
                    </select>
                            
                         
                  

            
                    </Col>

                    <Col lg={6} className="mb-3">
                      <Label
                        for="contactType"
                        className="form-label"
                      >
                      Tipo de identificación
                      </Label>
                    <select
                            className="form-select"
                            id="documentType"
                            name="documentType"
                           
                            value={documentType}   
                            onChange={onChange}
                             
                            
                          >
                             <option value="">Seleccione</option>

                                                                {Array.isArray(optionGroupTipoIdentificacion) ?
                                                                      optionGroupTipoIdentificacion[0].options.map((item) => (
                                                                        <option
                                                                          key={item.value}
                                                                          value={item.value}
                                                                        >
                                                                          {item.label}
                                                                        </option>
                                                                      )):[]}

                          </select>
                    </Col>     
                            
                </Row>

                 

                      {/* Documento y CIudad */}
                      <Row>


                    <Col lg={6} className="mb-3">
                      <Label
                        for="documento"
                        className="form-label"
                      >
                        Documento
                      </Label>
                      <Input
                        id="documentNumber"
                        name="documentNumber"
                        type="number"
                        onChange={onChange}
                          
                        value={documentNumber}   
                       
                      />
             {error && error.documentNumber ? (
                                                      <Alert color = 'danger' className="mt-2">{error.documentNumber}</Alert>
                                                      ):null}

                     </Col>

                    <Col lg={6} className="mb-3">
                      <Label
                        for="city"
                        className="form-label"
                      >
                        Ciudad
                      </Label>
                      <Input
                        id="city"
                        name="city"
                        type="text"
                        onChange={onChange}
                  
                        value={city}   
                       
                      />
                     
                    </Col>

                    </Row>

                   
  {/* Botones de abajo */}
                            <Row>
                              <Col>
                                <div className="text-end">
                                  <button
                                    type="button"
                                    className="btn btn-light me-2"
                                    onClick={handleButtonClick}
                                  >
                                    Close
                                  </button>
                                 
                                  <button
                                    type="submit"
                                    className="btn btn-success save-event"
                                  
                                  >
                                    Save
                                  </button>
                                </div>
                              </Col>
                            </Row>

                         </Form>                                               

                </ModalBody>
                </Modal>
        </React.Fragment>
     );
}
 

const mapStateToProps = (state) => {
    const { error, loading,contacts, contactsCreated } = state.Contacts;
    return { error, loading,contacts, contactsCreated};
  };


  CrearContactoModal.propTypes = {
    error: PropTypes.any,
    loading: PropTypes.bool,
    contactsCreated: PropTypes.object,
  };
  export default withRouter(connect(mapStateToProps, { contactsCreate })(CrearContactoModal));